import { render } from "./vedio.vue?vue&type=template&id=42287db2&scoped=true"
import script from "./vedio.vue?vue&type=script&lang=js"
export * from "./vedio.vue?vue&type=script&lang=js"

import "./vedio.vue?vue&type=style&index=0&id=42287db2&scoped=true&lang=css"
import "./vedio.vue?vue&type=style&index=1&id=42287db2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42287db2"]])

export default __exports__